<script lang="ts">
  import { eMailNewsletter } from "$lib/client/services/nurture";
  import { community } from "$lib/client/stores/nucamp-community";
  import dayjs from "dayjs";
  import { toast } from "svelte-sonner";
  import { geolocation } from "$lib/client/stores/nucamp-geolocation";
  import { Crisp } from "crisp-sdk-web";

  let email: string = "";

  function showStephanie() {
    Crisp.chat.show();
    Crisp.message.show("text", "Welcome Back! How can I help?");
  }

  async function subscribeNewsletter() {
    if (email) {
      const loading = toast.loading("Please wait...", {duration: Number.POSITIVE_INFINITY});
      await eMailNewsletter(email);
      toast.dismiss(loading);
      toast.success("You have successfully subscribed to our newsletter!", {
        description: "You will receive updates on new bootcamps, scholarships, and more.",
        action: {
          label: "Ok",
          onClick: () => {}
        }
      });
    } else [
      toast.error("Please enter your email address to subscribe to our newsletter.")
    ]
  }
</script>
<footer class="p-4 md:py-10 md:px-4 footer bg-base-200 text-base-content">
  <nav>
    <h6 class="footer-title">Newsletter</h6> 
    <div class="form-control">
      <label class="label" for="email">
        <span class="label-text">Enter your email address</span>
      </label> 
      <div class="join">
        <input type="text" id="email" bind:value={email} placeholder="username@site.com" class="input input-bordered text-sm join-item w-[85%]" /> 
        <button class="btn bg-nucamp-light hover:bg-nucamp-light-hover text-slate-100 join-item" on:click={() => subscribeNewsletter()}>Subscribe</button>
      </div>
    </div>
  </nav>
  <nav>
    <h6 class="footer-title">Connect</h6> 
    <a class="link link-hover" target="_blank" href="mailto:info@nucamp.co" title="Email Nucamp"><ion-icon name="mail-outline"></ion-icon> info@nucamp.co</a>
    {#if (!$geolocation || $geolocation?.country_code2 === 'US' || $geolocation?.country_code2 === 'CA')}
      <a class="link link-hover" target="_blank" href="https://calendly.com/nucamp-advisor/learnmore" title="Schedule a call with a Nucamp Advisor"><ion-icon name="calendar-outline"></ion-icon> Schedule a call with a Nucamp Advisor</a>
    <!-- Else statement -->
    {:else}
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <!-- svelte-ignore a11y-no-static-element-interactions -->
      <span class="link link-hover" on:click={() => showStephanie()}><ion-icon name="calendar-outline"></ion-icon> Discuss with Stephanie now</span>
    {/if}
    <!-- <a class="link link-hover" target="_blank" href="tel:1-888-803-3963" title="Call our Call out toll-free number"><ion-icon name="call-outline"></ion-icon> Call our toll-free number</a> -->
    <a class="link link-hover pt-2" target="_blank" href="https://www.facebook.com/nucamp.co" title="Like us on Facebook"><ion-icon name="logo-facebook"></ion-icon> Like us on Facebook</a>
    <a class="link link-hover" target="_blank" href="https://www.instagram.com/nucampcodingbootcamp/" title="Like us on Instagram"><ion-icon name="logo-instagram"></ion-icon> Follow us on Instagram</a>
    <a class="link link-hover" target="_blank" href="https://www.linkedin.com/school/nucamp/" title="Find us on LinkedIn"><ion-icon name="logo-linkedin"></ion-icon> Find an alumni on LinkedIn</a>
    <a class="link link-hover" target="_blank" href="https://www.youtube.com/c/Nucamp" title="Watch us on YouTube"><ion-icon name="logo-youtube"></ion-icon> Watch us on YouTube</a>
    <a class="link link-hover" target="_blank" href="https://twitter.com/nucampcodingbc" title="Chat with us on Twitter"><ion-icon name="logo-twitter"></ion-icon> Chat with us on Twitter</a>
    <a class="link link-hover" target="_blank" href="https://www.tiktok.com/@nucamp.co" title="Watch us on TikTok"><ion-icon name="logo-tiktok"></ion-icon> Watch us on TikTok</a>
  </nav> 
  <nav>
    <h6 class="footer-title">Bootcamps</h6>
    <span style="display:none"><a href="/browsecommunities?allcommunities=true">
      All Nucamp Vibe Coding Bootcamp Communities</a></span>
    <a class="link link-hover" href="/">Home</a>
    <a class="link link-hover" href="/community/{$community?.urlId ?? ''}">Your Community</a>
    <a class="link link-hover" href="/frequentlyaskedquestions">Testimonials & FAQ</a>
    <a class="link link-hover" href="/financing">Financing</a>
    <a class="link link-hover" href="/scholarships">Scholarships</a>
  </nav>
  <nav>
    <h6 class="footer-title">Company</h6> 
    <a class="link link-hover" href="/aboutus">About</a>
    <a class="link link-hover" href="/blogs">Blog</a>
    <a class="link link-hover" href="/privacy">Privacy</a>
    <a class="link link-hover" href="/termsofuse">Terms of Use & EUA</a>
    <a class="link link-hover" href="/codeofconduct">Code of Conduct</a>
    <a class="link link-hover" href="/regulatory">Regulatory Information</a>
    <a class="link link-hover" href="/affiliate/terms">Affiliate Program</a>
    <p class="pt-4 text-slate-500">{dayjs().format("YYYY")} &copy; Nucamp Inc. All rights reserved.<br>Bellevue, WA 98005.</p>
  </nav>
</footer> 